import { ReactElement } from "react";
import Layout from "../../components/layout";
import AddShop from "../../components/Shops/AddShop";

const ShopAddPage = (): ReactElement => {
  return (
    <Layout>
      <AddShop />
    </Layout>
  );
};

export default ShopAddPage;
